// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./PaymentMethodsRecord.bs.js";

function usePaypalTokenAndFlowFromExperience(paypalPaymentMethodExperience, sessionObj) {
  var paypalToken = React.useMemo((function () {
          return SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Paypal");
        }), [sessionObj]);
  var isPaypalSDKFlow = paypalPaymentMethodExperience.includes("InvokeSDK");
  var isPaypalRedirectFlow = paypalPaymentMethodExperience.includes("RedirectToURL");
  return {
          paypalToken: paypalToken,
          isPaypalSDKFlow: isPaypalSDKFlow,
          isPaypalRedirectFlow: isPaypalRedirectFlow
        };
}

function usePaymentMethodData(paymentMethodListValue, sessionObj) {
  var paypalPaymentMethodExperience = React.useMemo((function () {
          return PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(paymentMethodListValue, "wallet", "paypal");
        }), [paymentMethodListValue]);
  return usePaypalTokenAndFlowFromExperience(paypalPaymentMethodExperience, sessionObj);
}

export {
  usePaypalTokenAndFlowFromExperience ,
  usePaymentMethodData ,
}
/* react Not a pure module */
